<section class="location" id="location">
  <div class="location-twig location-twig--top">
    <img src="/backgrounds/twig.webp" alt="" aria-hidden="true" />
  </div>

  <div class="location-inner">
    <div class="location-header reveal">
      <p class="section-label">Where Kilimani Meets the Sky</p>
      <h2 class="location-title">At the Center of It All</h2>
      <p class="location-desc">
        Nestled in the heart of Kilimani, ACACIA occupies a commanding corner where city sophistication
        meets serene privacy. Steps from Lenana and Nyangumi Roads, and beside the Nigerian High Commission,
        it offers unrivaled access to Nairobi&apos;s finest shops, cafés, and cultural destinations — a
        location as elevated and discerning as the residence itself.
      </p>
    </div>

    <div class="location-map-card reveal reveal-delay-1">
      <div
        #mapShell
        class="map-shell"
        (pointerdown)="onPointerDown($event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp($event)"
        (pointercancel)="onPointerUp($event)"
        (wheel)="onWheel($event)"
      >
        <div class="map-viewport">
          @for (tile of mapTiles; track tile.id) {
            <img
              class="map-tile"
              [src]="tile.url"
              alt=""
              aria-hidden="true"
              [style.left.px]="tile.left"
              [style.top.px]="tile.top"
            />
          }

          @if (markerVisible) {
            <div class="map-pin" [style.left.px]="markerLeft" [style.top.px]="markerTop">
              <img src="/cursor.webp" alt="Acacia" class="pin-acacia" />
              <div class="pin-label">Acacia</div>
            </div>
          }
        </div>

        <div class="map-controls">
          <button type="button" class="map-control-btn" (click)="zoomIn()" aria-label="Zoom in">+</button>
          <button type="button" class="map-control-btn" (click)="zoomOut()" aria-label="Zoom out">−</button>
          <button type="button" class="map-control-btn map-control-reset" (click)="resetMap()">Reset</button>
        </div>

        <p class="map-hint">Drag to pan · Scroll to zoom</p>
      </div>
    </div>

    <div class="location-grid">
      @for (cat of categories; track cat.name; let i = $index) {
        <div class="loc-group reveal" [class]="'loc-group reveal reveal-delay-' + ((i % 4) + 1)">
          <div class="loc-group-header">
            <span class="loc-initial" [style.background]="cat.color">{{ cat.initial }}</span>
            <h3 class="loc-group-name">{{ cat.name }}</h3>
          </div>
          <ol class="loc-list">
            @for (item of cat.items; track item) {
              <li>{{ item }}</li>
            }
          </ol>
        </div>
      }
    </div>
  </div>

  <div class="location-marquee" aria-hidden="true">
    <div class="location-marquee-track">
      <img src="/silhouette.png" alt="" class="location-marquee-img" />
      <img src="/silhouette.png" alt="" class="location-marquee-img" />
      <img src="/silhouette.png" alt="" class="location-marquee-img" />
      <img src="/silhouette.png" alt="" class="location-marquee-img" />
    </div>
  </div>
</section>
